import React from 'react';
import Modal from '../ui/Modal';
import LegalDocumentContent from './LegalDocumentContent';
import { LEGAL_DOCUMENTS } from '../../constants/legal';

const LegalDocumentModal = ({ type, onClose }) => {
  if (!type) return null;
  const legalDocument = LEGAL_DOCUMENTS[type] || LEGAL_DOCUMENTS.privacy;

  return (
    <Modal isOpen onClose={onClose} title={legalDocument.shortTitle}>
      <LegalDocumentContent type={type} dense />
    </Modal>
  );
};

export default LegalDocumentModal;
